module.exports = __webpack_public_path__ + "static/img/NoData.4ffe9775.svg";